<div class="row">
  <div class="col-sm-12 col-md-6 col-md-offset-3">
    <h2>Upload list of users</h2>
    <div class="error-container" aria-live="assertive">
      <div class="alert valign-children-middle" *ngIf="bulkUploadError">
        <div class="alert-error" aria-label="Alert.">
          <i class="icon-badgealert" aria-hidden="true"></i>
        </div>
        <div>
          <h2>Error</h2>
          <p>{{bulkUploadError}}</p>
        </div>
      </div>
    </div>
    <p *ngIf="!uploadStatus"></p>
    <div *ngIf="!uploadStatus">
      <div class="form-group">
        <div class="col-sm-12 col-md-12">
          <!-- <label aria-label="Select file." class="btn btn-secondary" for="file-upload" tabindex="0">Select file</label>-->
          <button aria-label="Select file." class="btn btn-secondary" (click)="fileInput.click()">Select file</button>
          <label for="file-upload"><div class="hide-element">File upload</div></label> 
          <input id="file-upload" type="file" (change)="upload()" #fileInput style="display: none" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          />
        </div>
      </div>
      <label *ngIf="uploadFileName">File name:</label><i>{{uploadFileName}}</i>
    </div>
    
    <div *ngIf="uploadStatus">  
      <div class="row" aria-live="assertive">   
        <div class="col-sm-12 col-md-12 success-msg">
          <div class="hide-sm"><i class="icon-controls-approvalL icon-large" aria-hidden="true"> </i> <h3> Success </h3><p>Your file has been uploaded.</p> </div>
          <div class="show-sm"><i class="icon-approval" aria-hidden="true"> </i> <h3> Success </h3> <p>Your file has been uploaded.</p></div>
        </div>
      </div>
      <p><i>Filename: {{uploadFileName}}</i></p>
      <button aria-label="Select file." class="btn btn-secondary" (click)="fileInput.click()" style="display: none">Select file</button>
      <input id="file-upload" type="file" (change)="upload()" #fileInput style="display: none" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"/>
      <a href="javascript:void(0)" (click)="fileInput.click()">Replace uploaded file</a>
    </div>
    <hr class="bottom-hr" />
    <div class="line-footer text-right">
      <button type="button" [disabled]="bulkUploadFlag" class="btn btn-secondary btn-sm-block pull-right" (click)="gotoReview()">Continue</button>
      <a href="javascript:void(0)" class="btn btn-link btn-sm-block" (click)="cancel()">Back</a>
    </div>
  </div>
</div>